export default function( umbrella ) {
    const requestMiddleware = [];

    function applyRequestMiddleware( fn ) {
        requestMiddleware.push( fn );
    }

    function clientFetch( url, options = {} ) {
        requestMiddleware.forEach( ( fn ) => {
            fn( url, options );
        } );

        return fetch( url, options );
    }

    umbrella.fetch = clientFetch;
    umbrella.applyRequestMiddleware = applyRequestMiddleware;
}
